import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import type { SelectProps } from '@mui/material/Select';
import Select from '@mui/material/Select';
import useId from '@mui/utils/useId';
export interface OutlinedFieldMenuProps extends Omit<SelectProps, 'label' | 'options' | 'value' | 'autoWidth' | 'displayEmpty'> {
  id?: string;
  label: string;
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}
export function OutlinedFieldMenu(t0) {
  const $ = _c(38);
  let children;
  let id;
  let label;
  let onCloseProp;
  let onOpenProp;
  let openProp;
  let props;
  if ($[0] !== t0) {
    ({
      id,
      label,
      children,
      open: openProp,
      onClose: onCloseProp,
      onOpen: onOpenProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = id;
    $[3] = label;
    $[4] = onCloseProp;
    $[5] = onOpenProp;
    $[6] = openProp;
    $[7] = props;
  } else {
    children = $[1];
    id = $[2];
    label = $[3];
    onCloseProp = $[4];
    onOpenProp = $[5];
    openProp = $[6];
    props = $[7];
  }
  const elId = useId(id || "outline-field-menu");
  const labelId = `${elId}-label`;
  const [uncontrolledOpen, setUncontrolledOpen] = React.useState(false);
  const isControlled = openProp !== undefined;
  const open = isControlled ? openProp : uncontrolledOpen;
  let t1;
  if ($[8] !== isControlled || $[9] !== onCloseProp) {
    t1 = function handleClose() {
      if (onCloseProp) {
        onCloseProp();
      }
      if (!isControlled) {
        setUncontrolledOpen(false);
      }
    };
    $[8] = isControlled;
    $[9] = onCloseProp;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const handleClose = t1;
  let t2;
  if ($[11] !== isControlled || $[12] !== onOpenProp) {
    t2 = function handleOpen() {
      if (onOpenProp) {
        onOpenProp();
      }
      if (!isControlled) {
        setUncontrolledOpen(true);
      }
    };
    $[11] = isControlled;
    $[12] = onOpenProp;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const handleOpen = t2;
  let t3;
  if ($[14] !== label || $[15] !== labelId) {
    t3 = <InputLabel shrink={true} id={labelId}>{label}</InputLabel>;
    $[14] = label;
    $[15] = labelId;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const t4 = props.MenuProps?.slots;
  let t5;
  if ($[17] !== children || $[18] !== props.MenuProps?.slots) {
    t5 = props.MenuProps?.slots?.list ? props.MenuProps?.slots.list : () => <Box sx={{
      p: 2
    }}>{children}</Box>;
    $[17] = children;
    $[18] = props.MenuProps?.slots;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = {
      ...t4,
      list: t5
    };
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== props.MenuProps || $[24] !== t6) {
    t7 = {
      ...props.MenuProps,
      slots: t6
    };
    $[23] = props.MenuProps;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== elId || $[27] !== handleClose || $[28] !== handleOpen || $[29] !== label || $[30] !== labelId || $[31] !== open || $[32] !== props || $[33] !== t7) {
    t8 = <Select {...props} labelId={labelId} id={elId} value="" displayEmpty={true} label={label} open={open} autoWidth={true} onClose={handleClose} onOpen={handleOpen} MenuProps={t7} />;
    $[26] = elId;
    $[27] = handleClose;
    $[28] = handleOpen;
    $[29] = label;
    $[30] = labelId;
    $[31] = open;
    $[32] = props;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== t3 || $[36] !== t8) {
    t9 = <FormControl fullWidth={true}>{t3}{t8}</FormControl>;
    $[35] = t3;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
}